import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { fetchSingleMaterial, updateMaterialEntry } from '../../Store/PHPSlice/Material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectlocationdata } from '../Selectors/Master/ItemSelectors';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const MaterialEdit = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        materialId: parseInt(Id),
        materialNm: '',
        desp: '',
        size: '',
        pkts: '',
        userId: userdata?.ID,
        locId: ''
    });

    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const singleMaterial = useSelector((state) => state.MaterialData.singleMaterial || { data: [] });
    const loclist = useSelector(selectlocationdata);
    useEffect(() => {
        dispatch(fetchSingleMaterial(Id));
        dispatch(fetchLocationData());
    }, [dispatch, Id]);

    useEffect(() => {
        if (singleMaterial.data.length > 0) {
            const item = singleMaterial.data[0];
            setFormData({
                ...formData,
                materialNm: item.materialNm,
                desp: item.description,
                size: item.size,
                pkts: item.packets,
                locId: item.locId
            });
        }
    }, [singleMaterial]);
    // console.log(singleMaterial)
    if (!singleMaterial) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(updateMaterialEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Material Added");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const dropdownFirm = [

        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };

    return (
        <>

            <div style={{ margin: '1%' }}>
                <h2>Material Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={2}>

                                {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                }


                                {[
                                    { label: 'Material Name', name: 'materialNm' },
                                    { label: 'Description', name: 'desp' },
                                    { label: 'Size', name: 'size' },
                                    { label: 'Packets', name: 'pkts' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>


            </div>
        </>
    );
}

export default MaterialEdit;
